<script setup>
import { accentColor } from './unifiedSidebar';

defineProps({
  product: { type: Object, required: true },
  products: { type: Array, default: () => [] },
  activeProductKey: { type: String, required: true },
  collapsed: { type: Boolean, default: false },
});

const emit = defineEmits(['select-product']);

const productButtonStyle = (entry, active) => {
  const color = accentColor(entry.accent);
  return {
    backgroundColor: active
      ? `color-mix(in srgb, ${color} 12%, transparent)`
      : 'transparent',
  };
};
</script>

<template>
  <div
    class="flex items-center flex-wrap gap-3 w-full border-b border-n-weak"
    :class="
      collapsed
        ? 'justify-center px-0 pb-[0.85rem] pt-[0.15rem]'
        : 'justify-start px-[0.85rem] pb-[0.85rem] pt-[0.15rem]'
    "
  >
    <div
      v-if="!collapsed"
      class="flex items-center gap-[0.55rem] min-w-0"
    >
      <template v-if="product.logoUrl">
        <img
          :src="product.logoUrl"
          :alt="product.label"
          class="block dark:hidden h-7 w-auto max-w-full object-contain"
        />
        <img
          :src="product.logoDarkUrl"
          :alt="product.label"
          class="hidden dark:block h-7 w-auto max-w-full object-contain"
        />
      </template>
      <template v-else>
        <span
          class="inline-flex items-center justify-center size-7 rounded-full flex-shrink-0"
          :style="{ color: accentColor(product.accent) }"
        >
          <img
            v-if="product.iconUrl"
            :src="product.iconUrl"
            alt=""
            aria-hidden="true"
            width="20"
            height="20"
          />
        </span>
        <span
          class="text-[15px] font-bold font-sans text-n-slate-12 whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {{ product.label }}
        </span>
      </template>
    </div>

    <span
      v-else
      class="inline-flex items-center justify-center size-7 rounded-full"
      :style="{ color: accentColor(product.accent) }"
    >
      <img
        v-if="product.iconUrl"
        :src="product.iconUrl"
        :alt="product.label"
        width="20"
        height="20"
      />
    </span>

    <div
      v-if="products.length > 1"
      class="flex md:hidden items-center gap-2 w-full"
    >
      <button
        v-for="entry in products"
        :key="entry.key"
        type="button"
        class="inline-flex items-center justify-center size-[2.35rem] border-0 rounded-full p-0 cursor-pointer"
        :style="productButtonStyle(entry, entry.key === activeProductKey)"
        :title="entry.label"
        :aria-label="entry.label"
        :aria-pressed="entry.key === activeProductKey"
        @click="emit('select-product', entry)"
      >
        <img
          :src="entry.iconUrl"
          alt=""
          aria-hidden="true"
          class="size-[1.35rem] object-contain"
        />
      </button>
    </div>
  </div>
</template>
